import { fulfillmentApi } from '../../../api/fulfillmentApi';
import { IEntityToDisable } from '../../../models/entityToDisable';
import { createSubActivity, ISubActivity } from '../../../models/subActivities';
import { AppDispatch, RootState } from '../../store';
import { setSubActivities, setSubActivity, startLoadingSubActivities, updateSubActivities } from './subActivitiesSlice';

export const getSubActivities = (idActivity?: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingSubActivities());

        let subActivities = {};
        if (idActivity) {
            const resp = await fulfillmentApi.get(`subActivities/GetSubActivitiesPerActivity/${idActivity}`);
            subActivities = resp.data;
        }
        else {
            const resp = await fulfillmentApi.get(`subActivities`);
            subActivities = resp.data;
        }

        dispatch(setSubActivities({ subActivities }));
    }
}

export const getSubActivity = (subActivityId: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingSubActivities());

        const resp = await fulfillmentApi.get(`subActivities/${subActivityId}`);
        dispatch(setSubActivity({ subActivity: resp.data }));
    }
}

export const saveSubActivity = (subActivity: ISubActivity) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingSubActivities());
        const newSubActivity = createSubActivity(subActivity);
        await fulfillmentApi.post(`subActivities`, newSubActivity);

        const resp = await fulfillmentApi.get(`subActivities`);
        let subActivities = {};
        subActivities = resp.data;

        dispatch(setSubActivities({ subActivities }));
    }
}

export const editSubActivity = (subActivity: ISubActivity) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingSubActivities());

        await fulfillmentApi.put(`subActivities/${subActivity.id}`, subActivity);

        const resp = await fulfillmentApi.get(`subActivities/${subActivity.id}`);

        dispatch(setSubActivity({ subActivity: resp.data }));
        dispatch(updateSubActivities({ subActivity: resp.data }));
    }
}

export const disableSubActivity = (entityToDisable: IEntityToDisable) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingSubActivities());

        await fulfillmentApi.put(`subActivities/expire/${entityToDisable.id}`, entityToDisable);

        const resp = await fulfillmentApi.get(`subActivities/${entityToDisable.id}`);

        dispatch(setSubActivity({ subActivity: resp.data }));
        dispatch(updateSubActivities({ subActivity: resp.data }));
    }
}
